import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import OurStory from "@/pages/OurStory";
import TheProcess from "@/pages/TheProcess";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import BundleBuilder from "@/pages/BundleBuilder";
import Admin from "@/pages/Admin";
import Reviews from "@/pages/Reviews";
import Privacy from "@/pages/Privacy";
import ShippingReturns from "@/pages/ShippingReturns";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <CartProvider>
                    <Header />
                    <CartDrawer />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/shop/:category" element={<Shop />} />
                            <Route path="/bundles" element={<BundleBuilder />} />
                            <Route path="/product/:slug" element={<ProductDetail />} />
                            <Route path="/our-story" element={<OurStory />} />
                            <Route path="/tradition" element={<Navigate to="/our-story#tradition" replace />} />
                            <Route path="/process" element={<TheProcess />} />
                            <Route path="/the-process" element={<TheProcess />} />
                            <Route path="/ingredients" element={<Navigate to="/process#ingredients" replace />} />
                            <Route path="/journal" element={<Journal />} />
                            <Route path="/journal/:slug" element={<JournalPost />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/reviews" element={<Reviews />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/shipping-returns" element={<ShippingReturns />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/checkout/success" element={<CheckoutSuccess />} />
                            <Route path="/admin" element={<Admin />} />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster
                        position="bottom-center"
                        toastOptions={{
                            style: {
                                background: "#1C1C1A",
                                color: "#FAF9F6",
                                border: "none",
                                borderRadius: 0,
                                fontFamily: "Manrope, sans-serif",
                                fontSize: "13px",
                                letterSpacing: "0.04em",
                            },
                        }}
                    />
                </CartProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
